// AF-3.16 — DecisionCard (AF-3.6 CreativeDecisionService).
//
// Exposes recommendation/score/confidence/hard-constraints/weaknesses/
// governance/readiness/revision-requirements verbatim from the backend
// decision object. Only shows lifecycle states that actually exist on
// the object -- never invents a state to make the UI look complete
// (spec Section 16).

import { StatusBadge, ConfidenceIndicator, ReadinessBadge, GovernanceBadge, GovernanceNote } from "./Badges";

export function DecisionCard({ decision, testId = "decision-card" }) {
  if (!decision) return null;
  const {
    decision: verdict, score, confidence, hard_constraints_violated = [],
    weaknesses = [], governance_status, readiness, revision_requirements = [],
  } = decision;

  return (
    <div data-testid={testId} className="rounded-[var(--radius-card)] border border-[var(--border)] bg-[var(--surface)] p-4 shadow-[var(--shadow-card)]">
      <div className="flex items-center justify-between mb-3">
        <p className="text-[10px] font-mono uppercase text-[var(--text-tertiary)]">Decision</p>
        <StatusBadge value={verdict} />
      </div>

      <div className="grid grid-cols-2 gap-3 mb-3 text-[11px]">
        {score !== undefined && score !== null && (
          <div><p className="text-[10px] font-mono uppercase text-[var(--text-tertiary)]">Score</p><p className="text-[var(--text-primary)] font-mono">{score}</p></div>
        )}
        {confidence !== undefined && confidence !== null && (
          <div><p className="text-[10px] font-mono uppercase text-[var(--text-tertiary)]">Confidence</p><ConfidenceIndicator value={confidence} /></div>
        )}
        {governance_status && (
          <div>
            <p className="text-[10px] font-mono uppercase text-[var(--text-tertiary)]">Governance</p>
            <GovernanceBadge value={governance_status} />
            <GovernanceNote value={governance_status} />
          </div>
        )}
        {readiness && <div><p className="text-[10px] font-mono uppercase text-[var(--text-tertiary)]">Readiness</p><ReadinessBadge value={readiness} /></div>}
      </div>

      {hard_constraints_violated.length > 0 && (
        <div className="mb-2 px-2.5 py-2 rounded bg-[var(--error-bg)] border border-[var(--error-border)]">
          <p className="text-[10px] font-mono uppercase text-[var(--error)]">Hard constraints violated</p>
          <p className="text-[11px] text-[var(--text-secondary)]">{hard_constraints_violated.join(", ")}</p>
        </div>
      )}

      {weaknesses.length > 0 && (
        <div className="mb-2">
          <p className="text-[10px] font-mono uppercase text-[var(--text-tertiary)]">Weaknesses</p>
          <ul className="text-[11px] text-[var(--text-secondary)] list-disc list-inside">
            {weaknesses.map((w, i) => <li key={i}>{w}</li>)}
          </ul>
        </div>
      )}

      {revision_requirements.length > 0 && (
        <div>
          <p className="text-[10px] font-mono uppercase text-[var(--text-tertiary)]">Revision requirements</p>
          <ul className="text-[11px] text-[var(--text-secondary)] list-disc list-inside">
            {revision_requirements.map((r, i) => <li key={i}>{r}</li>)}
          </ul>
        </div>
      )}
    </div>
  );
}
